/* Progressive search overlay. Matching and prices are rendered by Shopify, never a client catalogue. */
(() => {
  'use strict';
  if (window.__r26HeaderSearch) return;
  window.__r26HeaderSearch = true;
  function init(scope = document) {
    scope.querySelectorAll('[data-r26-search-dialog]').forEach(dialog => {
      if (dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
      dialog.dataset.ready = 'true';
      const events = new AbortController(), signal = events.signal;
      const form = dialog.querySelector('form'), input = form.querySelector('[name="q"]');
      const target = dialog.querySelector('[data-r26-search-target]'), status = dialog.querySelector('[data-r26-search-status]');
      const all = dialog.querySelector('[data-r26-search-all]'), fallback = dialog.querySelector('[data-r26-search-fallback]');
      let trigger = null, returnTarget = null, controller = null, debounce = 0, timeout = 0, version = 0, backdropDown = false, restoreFocus = true;
      const cancel = () => { ++version; clearTimeout(debounce); clearTimeout(timeout); controller?.abort(); controller = null; target.setAttribute('aria-busy', 'false'); };
      const fullURL = (query, pageHref) => {
        const route = new URL(form.action, location.origin);
        const url = pageHref ? new URL(pageHref, route) : route;
        if (url.origin !== route.origin || url.pathname !== route.pathname) throw new Error('Invalid search page');
        url.searchParams.delete('section_id'); url.hash = '';
        url.searchParams.set('q', query); url.searchParams.set('type', 'product'); url.searchParams.set('options[prefix]', 'last');
        return url.href;
      };
      async function load(url, focusResults = false) {
        const current = ++version;
        const request = new AbortController(); controller = request;
        timeout = setTimeout(() => request.abort(), 8000);
        try {
          const response = await fetch(url.href, {signal:request.signal, credentials:'same-origin', headers:{Accept:'text/html'}});
          if (!response.ok) throw new Error('Search response');
          const html = await response.text();
          if (current !== version || !dialog.open) return;
          const results = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-r26-search-results]');
          if (!results) throw new Error('Search section unavailable');
          target.replaceChildren(...results.children);
          target.dataset.searchMode = results.dataset.searchMode || 'predictive';
          status.textContent = results.dataset.summary || '';
          target.scrollTop = 0;
          if (focusResults) target.focus({preventScroll:true});
        } catch {
          if (current !== version || !dialog.open) return;
          target.replaceChildren(); target.dataset.searchMode = 'error'; status.textContent = dialog.dataset.error;
          fallback.hidden = false;
        } finally {
          if (current === version) { clearTimeout(timeout); controller = null; target.setAttribute('aria-busy', 'false'); }
        }
      }
      const predictive = query => {
        const url = new URL(dialog.dataset.predictiveUrl, location.origin);
        url.searchParams.set('q', query); url.searchParams.set('section_id', 'r26-predictive-search');
        url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        load(url);
      };
      const schedule = () => {
        cancel(); target.replaceChildren(); fallback.hidden = true;
        const query = input.value.trim();
        target.dataset.searchMode = query ? 'predictive-loading' : 'idle';
        all.href = fallback.href = fullURL(query); all.hidden = !query;
        if (!query) { status.textContent = dialog.dataset.intro; return; }
        status.textContent = dialog.dataset.loading; target.setAttribute('aria-busy', 'true');
        debounce = setTimeout(() => predictive(query), 180);
      };
      const fullSearch = pageHref => {
        const query = input.value.trim();
        if (!query) { schedule(); input.focus(); return; }
        cancel(); target.replaceChildren(); all.hidden = true; fallback.hidden = true;
        target.dataset.searchMode = 'full-loading';
        status.textContent = dialog.dataset.loading; status.focus({preventScroll:true});
        target.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(fullURL(query, pageHref)); fallback.href = url.href;
          url.searchParams.set('section_id', 'r26-search-results');
          load(url, true);
        } catch {
          target.setAttribute('aria-busy', 'false'); target.dataset.searchMode = 'error'; status.textContent = dialog.dataset.error;
          fallback.href = fullURL(query); fallback.hidden = false;
        }
      };
      const close = (focus = true) => { restoreFocus = focus; cancel(); if (dialog.open) dialog.close(); };
      document.addEventListener('click', event => {
        const link = event.target.closest('[data-r26-search-open]');
        if (!link || link.getAttribute('aria-controls') !== dialog.id || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (dialog.open) { input.focus({preventScroll:true}); return; }
        trigger = link;
        const burger = link.closest('[data-r19-burger]');
        returnTarget = burger?.querySelector('summary') || link;
        document.querySelectorAll('[data-r19-header] details[open]').forEach(details => { details.open = false; });
        restoreFocus = true;
        dialog.showModal(); document.body.classList.add('r26-search-open'); trigger.setAttribute('aria-expanded', 'true');
        input.focus({preventScroll:true}); schedule();
      }, {signal});
      input.addEventListener('input', event => { if (!event.isComposing) schedule(); }, {signal});
      input.addEventListener('compositionend', schedule, {signal});
      form.addEventListener('submit', event => {
        event.preventDefault(); fullSearch();
      }, {signal});
      dialog.addEventListener('click', event => {
        const link = event.target.closest('[data-r26-search-all], [data-r26-search-page]');
        if (!link || !dialog.contains(link) || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); fullSearch(link.hasAttribute('data-r26-search-page') ? link.getAttribute('href') : undefined);
      }, {signal});
      dialog.querySelector('[data-r26-search-close]').addEventListener('click', () => close(), {signal});
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); }, {signal});
      dialog.addEventListener('close', () => {
        cancel(); document.body.classList.remove('r26-search-open'); trigger?.setAttribute('aria-expanded', 'false');
        if (restoreFocus && returnTarget?.isConnected && returnTarget.getClientRects().length) returnTarget.focus({preventScroll:true});
      }, {signal});
      const outside = event => { const rect = dialog.getBoundingClientRect(); return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom; };
      dialog.addEventListener('pointerdown', event => { backdropDown = event.target === dialog && outside(event); }, {signal});
      dialog.addEventListener('click', event => { if (backdropDown && event.target === dialog && outside(event)) close(); backdropDown = false; }, {signal});
      dialog.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); return; }
        if (event.key === 'ArrowDown' && event.target === input) { const first = target.querySelector('a[href]'); if (first) { event.preventDefault(); first.focus(); } }
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('a[href],button,input')].filter(node => !node.disabled && node.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, {signal});
      window.addEventListener('pagehide', () => close(false), {signal});
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(dialog)) return;
        close(false); document.body.classList.remove('r26-search-open'); events.abort(); delete dialog.dataset.ready;
      }, {signal});
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
